import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";

import Header from "../components/Header";
import Footer from "../components/Footer";
import ErrorBoundary from "../components/ErrorBoundary";

import Home from "../pages/home/Home";
import ContactUs from "../pages/contactus/Contact-Us";
import Reviews from "../pages/contactus/Reviews";
import MiamiDade from "../pages/location/Miami-Dade";
import BrowardCounty from "../pages/location/Broward-County";
import PalmBeachCounty from "../pages/location/Palm-Beach-County";
import CentralFlorida from "../pages/location/Central-Florida";
import AllLocations from "../pages/location/AllLocations";
import Faq from "../pages/faq/FAQ";
import LocationDetails from "../components/LocationDetails/LocationDetails";

// Layouts
import BasicLayout from "../layouts/BasicLayout";
import LayoutOne from "../layouts/LayoutOne";
import LayoutTwo from "../layouts/LayoutTwo";

// Pages
import CustomerSupport from "../pages/contactus/CustomerSupport";
import DuiSchool from "../pages/dui-school/DuiSchool";
import OnlineTrafficSchool from "../pages/online-traffic-school/OnlineTrafficSchool";
import FourHourBDI from "../pages/online-traffic-school/FourHourBDI";
import FourHourBasicDriver from "../pages/online-traffic-school/FourHourBasicDriver";
import EightHourIDI from "../pages/online-traffic-school/EightHourIDI";
import FirstTimeDriver from "../pages/first-time-driver/FirstTimeDriver";
import FourHourDrugAlcohol from "../pages/drug-alcohol-course/FourHourDrugAlcohol";
import TwelveHourADI from "../pages/adi-course/TwelveHourADI";
import TrafficSchoolProgram from "../pages/traffic-school-program/TrafficSchoolProgram";
import DuiLevel1 from "../pages/dui-school/DuiLevel1";
import DuiLevel2 from "../pages/dui-school/DuiLevel2";
import DuiSchoolDetails from "../pages/dui-school/DuiSchoolDetails";
import FloridaPermitTest from "../pages/florida-permit-test/FloridaPermitTest";
import FloridaDriverTestInPerson from "../pages/florida-permit-test/FloridaDriverTestInPerson";
import MatureDriverCourse from "../pages/mature-driver-course/MatureDriverCourse";
import ClassroomTrafficSchool from "../pages/classroom-traffic-school/ClassroomTrafficSchool";
import EightHourCourse from "../pages/8-hour-course/EightHourCourse";
import VictimImpact from "../pages/victim-impact/VictimImpact";
import PrepCourse from "../pages/prep-course/PrepCourse";
import DrivingLessons from "../pages/driving-lessons/DrivingLessons";
import GenericCountyDrivingLessons from "../pages/driving-lessons/GenericCountyDrivingLessons";
import FloridaDriverHandbook from "../pages/florida-driver-handbook/FloridaDriverHandbook";
import CoursesInSpanish from "../pages/courses-in-spanish/CoursesInSpanish";
import CursoParaMultas from "../pages/online-traffic-school/CursoParaMultas";
import CursoDeDUIEnEspanol from "../pages/online-traffic-school/CursoDeDUIEnEspanol";
import ExamenPracticoDeLicencia from "../pages/online-traffic-school/ExamenPracticoDeLicencia";
import DriverLicenseRoadTest from "../pages/driver-license-road-test/DriverLicenseRoadTest";
import CursoSacarLicencia from "../pages/curso-sacar-licencia/CursoSacarLicencia";
import ExamenTeorico from "../pages/online-traffic-school/ExamenTeorico";
import CursoAlcoholDrogas from "../pages/online-traffic-school/CursoAlcoholDrogas";
import CursoDePreparatoria from "../pages/online-traffic-school/CursoDePreparatoria";
import BureauAdministrativeReview from "../pages/dui-school/BureauAdministrativeReview";
import Curso4HorasBDI from "../pages/online-traffic-school/Curso4HorasBDI";
import ClasesDeManejo from "../pages/driving-lessons/ClasesDeManejo";
import ClasesDeManejoDetails from "../pages/driving-lessons/ClasesDeManejoDetails";
import DetsCourse from "../pages/dets/DetsCourse";
import DetsCourseEs from "../pages/dets/DetsCourseEs";


const Routing = (props) => {
  const RoutingData = [
    { path: "/", element: <Home /> },
    {
      path: "/contact-us",
      element: <ContactUs settings={props.settingData} />,
    },
    {
      path: "/reviews",
      element: <Reviews settings={props.settingData} />,
    },
    { path: "/location/:slug", element: <LocationDetails /> },
    { path: "/locations", element: <AllLocations /> },
    {
      path: "/miami-dade",
      element: <MiamiDade settings={props.settingData} />,
    },
    {
      path: "/broward-county",
      element: <BrowardCounty settings={props.settingData} />,
    },
    {
      path: "/palmbeach-county",
      element: <PalmBeachCounty settings={props.settingData} />,
    },
    {
      path: "/central-florida",
      element: <CentralFlorida settings={props.settingData} />,
    },
    // { path: "/login", element: <Login /> },
    { path: "/dui-school", element: <DuiSchool /> },
    { path: "/dui-level1", element: <DuiLevel1 /> },
    { path: "/dui-level2", element: <DuiLevel2 /> },
    {
      path: "/bureau-administrative-review-office",
      element: <BureauAdministrativeReview />,
    },
    { path: "/dui-school-details", element: <DuiSchoolDetails /> },
    { path: "/online-traffic-school", element: <OnlineTrafficSchool /> },
    { path: "/8-hour-idi-course", element: <EightHourIDI /> },
    { path: "/4-hour-bdi-online", element: <FourHourBDI /> },
    { path: "/4-hour-bdi", element: <FourHourBasicDriver /> },
    { path: "/first-time-driver", element: <FirstTimeDriver /> },
    { path: "/first-time-driver-course", element: <FourHourDrugAlcohol /> },
    { path: "/12-hour-adi", element: <TwelveHourADI /> },
    { path: "/traffic-school-program", element: <TrafficSchoolProgram /> },
    {
      path: "/online-course",
      element: <Navigate to="/online-traffic-school" replace />,
    },
    {
      path: "/customer-support",
      element: <CustomerSupport settings={props.settingData} />,
    },
    {
      path: "/florida-driving-test",
      element: <FloridaPermitTest />,
    },
    {
      path: "/dmv-test-in-person",
      element: <FloridaDriverTestInPerson />,
    },
    {
      path: "/florida-driver-handbook",
      element: <FloridaDriverHandbook />,
    },
    {
      path: "/cursos-en-espanol",
      element: <CoursesInSpanish />,
    },
    {
      path: "/curso-para-multas",
      element: <CursoParaMultas />,
    },
    {
      path: "/curso-de-4-horas",
      element: <Curso4HorasBDI />,
    },
    {
      path: "/dui-en-espanol",
      element: <CursoDeDUIEnEspanol />,
    },
    {
      path: "/examen-practico-de-licencia-de-conducir",
      element: <ExamenPracticoDeLicencia />,
    },
    {
      path: "/driver-license-road-test",
      element: <DriverLicenseRoadTest />,
    },
    {
      path: "/curso-para-obtener-la-licencia",
      element: <CursoSacarLicencia />,
    },
    {
      path: "/examen-teorico",
      element: <ExamenTeorico />,
    },
    {
      path: "/curso-de-alcohol-y-drogas",
      element: <CursoAlcoholDrogas />,
    },
    {
      path: "/dets-course",
      element: <DetsCourse />,
    },
    {
      path: "/dets-curso",
      element: <DetsCourseEs />,
    },
    {
      path: "/curso-de-preparatoria",
      element: <CursoDePreparatoria />,
    },
    {
      path: "/mature-driver-course",
      element: <MatureDriverCourse />,
    },
    {
      path: "/classroom-traffic-school",
      element: <ClassroomTrafficSchool />,
    },
    // {
    //   path: "/mission",
    //   element: <Mission />,
    // },
    {
      path: "/8-hour-idi",
      element: <EightHourCourse />,
    },
    {
      path: "/prep-course",
      element: <PrepCourse />,
    },
    {
      path: "/victim-impact",
      element: <VictimImpact />,
    },
    {
      path: "/driving-lessons",
      element: <DrivingLessons />,
    },
    {
      path: "/orange-county-driving-lessons",
      element: <GenericCountyDrivingLessons countyKey="orange" />,
    },
    {
      path: "/seminole-county-driving-lessons",
      element: <GenericCountyDrivingLessons countyKey="seminole" />,
    },
    {
      path: "/osceola-county-driving-lessons",
      element: <GenericCountyDrivingLessons countyKey="osceola" />,
    },
    {
      path: "/lake-county-driving-lessons",
      element: <GenericCountyDrivingLessons countyKey="lake" />,
    },
    {
      path: "/volusia-county-driving-lessons",
      element: <GenericCountyDrivingLessons countyKey="volusia" />,
    },
    {
      path: "/miami-dade-county-driving-lessons",
      element: <GenericCountyDrivingLessons countyKey="miami-dade" />,
    },
    {
      path: "/broward-county-driving-lessons",
      element: <GenericCountyDrivingLessons countyKey="broward" />,
    },
    {
      path: "/palm-beach-county-driving-lessons",
      element: <GenericCountyDrivingLessons countyKey="palm-beach" />,
    },
    {
      path: "/clases-de-manejo",
      element: <ClasesDeManejo />,
    },
    {
      path: "/clases-de-manejo/informacion",
      element: <ClasesDeManejoDetails />,
    },
    { path: "/faq", element: <Faq /> },
  ];

  if (props.menuData && props.menuData.length) {
    props.menuData.map((mData, mIndex) => {
      if (mData.type === "page") {
        RoutingData.push({
          path: `/${mData.slug}`,
          element:
            mData.layout === 1 ? (
              <LayoutOne slug={mData.slug} />
            ) : (
              <LayoutTwo slug={mData.slug} settings={props.settingData} />
            ),
          layout: mData.layout === 1 ? "Layout one" : "Layout two",
        });
      }
      if (mData.sub_menu?.length) {
        mData.sub_menu.map((sData) => {
          if (sData.type === "page") {
            RoutingData.push({
              path: `/${sData.slug}`,
              slug: sData.slug,
              element:
                sData.layout === 1 ? (
                  <LayoutOne slug={sData.slug} />
                ) : sData.layout === 2 ? (
                  <LayoutTwo slug={sData.slug} settings={props.settingData} />
                ) : (
                  <BasicLayout slug={sData.slug} />
                ),
              layout:
                sData.layout === 1
                  ? "Layout one"
                  : sData.layout === 2
                    ? "Layout two"
                    : "layout three",
            });
          }
        });
      }
    });
  }

  return (
    <BrowserRouter>
      <ErrorBoundary>
        <Routes>
          {RoutingData.map((data) => (
            <Route
              key={data.path}
              exact
              path={data.path}
              element={
                <>
                  <Header menus={props.menuData} settings={props.settingData} />
                  {data.element}
                  <Footer fMenu={props.menuData} />
                </>
              }
            />
          ))}
          {/* Catch-all: redirect unknown routes to home */}
          <Route path="*" element={<Navigate to="/" replace />} />
        </Routes>
      </ErrorBoundary>
    </BrowserRouter>
  );
};

export default Routing;
